import * as React from 'react';
import { useRecoilState } from 'recoil';
import { IWaypoint } from '../Waypoints/types';
import WaypointIconService from '../Waypoints/WaypointIconService';
import {
  WAYPOINT_MARKED,
  WAYPOINT_TYPE_DEFAULT,
  WAYPOINT_TYPE_PRIVATE,
} from '../Waypoints/constants';
import { waypointIdAtom } from '../Waypoints/WaypointState';
import useAnalytics from '../../../hooks/useAnalytics';

interface IWaypointMarkerProps {
  lat: number; // eslint-disable-line react/no-unused-prop-types
  lng: number; // eslint-disable-line react/no-unused-prop-types
  data: IWaypoint;
  zIndex: number;
}

function WaypointMarker(props: IWaypointMarkerProps): JSX.Element {
  const [isTooltipOpen, toggleIsTooltipOpen] = React.useReducer((state: boolean) => {
    return !state;
  }, false);
  const [waypointId, setWaypointId] = useRecoilState<number | null>(waypointIdAtom);
  const { trackEvent } = useAnalytics();

  const elementRef = React.useRef<HTMLDivElement | null>(null);

  const icon = WaypointIconService.getWaypointIcon(
    props.data.type === WAYPOINT_TYPE_PRIVATE,
    1,
    props.data.icon ? props.data.icon : '',
    waypointId === props.data.id
  );

  React.useEffect(() => {
    if (elementRef.current) {
      const markerElement = elementRef.current.parentElement;
      if (markerElement) {
        if (isTooltipOpen) {
          markerElement.style.zIndex = String(props.zIndex + 10000000000);
        } else {
          markerElement.style.zIndex = String(props.zIndex);
        }
      }
    }
  }, [isTooltipOpen, props.zIndex]);

  const handleWaypointTooltipColor = (): string => {
    if (waypointId === props.data.id) {
      return WAYPOINT_MARKED;
    }
    if (props.data.type === WAYPOINT_TYPE_PRIVATE) {
      return WAYPOINT_TYPE_DEFAULT;
    }
    return WAYPOINT_TYPE_PRIVATE;
  };

  const handleOnClickWp = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    trackEvent(['map', 'click', `Select waypoint via Marker ${props.data.id}`]);
    if (waypointId !== props.data.id) {
      setWaypointId(Number(props.data.id));
    } else {
      setWaypointId(null);
    }
  };

  return (
    <div
      style={{ transform: 'translate(-50%, -100%)', position: 'absolute', cursor: 'pointer' }}
      onMouseEnter={toggleIsTooltipOpen}
      onMouseLeave={toggleIsTooltipOpen}
      ref={elementRef}
      onClick={handleOnClickWp}
      id={`waypoint-marker-${props.data.id}`}
    >
      <div style={{ position: 'relative' }}>
        {isTooltipOpen && (
          <div
            className={`e-map-pin-info customer-${handleWaypointTooltipColor()}`}
            style={{
              position: 'absolute',
              top: -1,
              left: '50%',
              transform:
                waypointId === props.data.id ? 'translate(-50%, -225%)' : 'translate(-50%, -100%)',
            }}
          >
            <div>
              <span className="info">{props.data.name}</span>
            </div>
          </div>
        )}

        <img src={icon} alt="" />
      </div>
    </div>
  );
}

export default React.memo(WaypointMarker);
